export default {"src":"/_next/static/media/filequestion_regular.cdc0c837.svg","height":19,"width":18};